import React, { useState, useEffect } from "react";
import { Box, Button, TextField } from "@mui/material";
import { Col, Container, Row } from "react-bootstrap";
import Cookies from "js-cookie";

const Host3 = ({ onAdd, onGet, mode }) => {
  // 🔥 Local class inputs (previously in AuthContext)
  const [classes, setClasses] = useState({
    title: "",
    fee: "",
    description: "",
    date: "",
    time: "",
    duration: "",
  });

  // local error function
  const showError = (msg) => alert(msg);

  // Sort by date & time
  const sortEventsByDateTime = (events) => {
    return events.sort((a, b) => {
      const dateTimeA = new Date(`${a.date}T${a.time}`);
      const dateTimeB = new Date(`${b.date}T${b.time}`);
      return dateTimeA - dateTimeB;
    });
  };

  const today = new Date();
  const minDate = new Date(today.setDate(today.getDate() + 15));
  const formattedMinDate = minDate.toISOString().split("T")[0];

  const [currentClassList, setCurrentClassList] = useState([]);

  // Load from props
  useEffect(() => {
    const date = onGet();
    if (date) {
      const sorted = sortEventsByDateTime([...date]);
      setCurrentClassList(sorted);
    }
  }, []);

  // Load from cookies
  useEffect(() => {
    const saved = Cookies.get("state1cls");
    if (saved) {
      const parsed = JSON.parse(saved);
      const d = parsed["date"];
      if (d && d.length > 0) {
        const sorted = sortEventsByDateTime([...d]);
        setCurrentClassList(sorted);
      }
    }
  }, []);

  // Push updated list to parent
  useEffect(() => {
    onAdd(currentClassList);
  }, [currentClassList, onAdd]);

  return (
    <Container fluid className="p-0 m-0">
      {/* List */}
      <Container className="d-flex justify-content-center align-items-center mt-3">
        <div className="w-100 text-center mt-3">
          {currentClassList.length > 0 && (
            <h4 className="mb-4 fmfont">List Of Classes</h4>
          )}

          {currentClassList.length > 0 && (
            <b>
              <Row className="w-100 mb-2">
                <Col md={2}>No.</Col>
                <Col md={2}>Date</Col>
                <Col md={2}>Time</Col>
                <Col md={2}>Duration</Col>
                <Col md={2}>Action</Col>
              </Row>
            </b>
          )}

          {currentClassList.map((item, index) => (
            <Row className="w-100 mb-3" key={index}>
              <Col md={2}>#{index + 1}</Col>
              <Col md={2}>{item.date}</Col>
              <Col md={2}>{item.time}</Col>
              <Col md={2}>{item.duration} mins</Col>
              <Col md={2}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    const updated = currentClassList.filter(
                      (_, i) => i !== index
                    );
                    const sorted = sortEventsByDateTime(updated);
                    setCurrentClassList(sorted);
                  }}
                  className="deleteButtonOfC2 gb"
                >
                  Delete
                </Button>
              </Col>
            </Row>
          ))}
        </div>
      </Container>

      {/* Form */}
      <Container fluid className="d-flex justify-content-center m-0 p-0">
        <Container className="my-5 w-100 d-flex justify-content-center">
          <div className="d-flex justify-content-center w-100 m-2">
            <Box>
              <Row className="signupform">

                {/* DATE */}
                <Col md={4} xs={12}>
                  <input
                    type="date"
                    value={classes.date}
                    className="w-100 p-2 rounded-2 timefield border-1"
                    min={formattedMinDate}
                    onChange={(e) =>
                      setClasses({ ...classes, date: e.target.value })
                    }
                  />
                </Col>

                {/* TIME */}
                <Col md={4} xs={12}>
                  <input
                    type="time"
                    value={classes.time}
                    className="w-100 p-2 rounded-2 timefield border-1"
                    onChange={(e) =>
                      setClasses({ ...classes, time: e.target.value })
                    }
                  />
                </Col>

                {/* DURATION */}
                <Col md={4} xs={12}>
  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
    <TextField
      label="Duration"
      type="number"
      value={classes.duration}
      onChange={(e) =>
        setClasses({ ...classes, duration: e.target.value })
      }
      className="mb-3 w-100"
      InputProps={{
        inputProps: { min: 1, inputMode: "numeric" },
        sx: {
          "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
            { display: "none" },
          "& input[type=number]": { MozAppearance: "textfield" },
        },
      }}
      placeholder="e.g : 45"
    />
    <span style={{ whiteSpace: "nowrap", marginBottom: "16px" }}>
      min
    </span>
  </div>
</Col>

                {/* BUTTONS */}
                <Col md={12} className="mt-4">
                  <div className="d-flex justify-content-between">

                    {/* CLEAR */}
                    <Button
                      color="error"
                      variant="contained"
                      onClick={() =>
                        setClasses({
                          title: "",
                          fee: "",
                          description: "",
                          date: "",
                          time: "",
                          duration: "",
                        })
                      }
                      className="deleteButtonOfC2 gsb"
                    >
                      Clear
                    </Button>

                    {/* ADD BUTTON (only 1 class if mode=="class") */}
                    {!(mode === "class" && currentClassList.length >= 1) && (
                      <Button
                        color="primary"
                        variant="contained"
                        className="w-25 AddButtonOfC2 gb"
                        onClick={() => {
                          if (
                            !classes.date ||
                            !classes.time ||
                            !classes.duration
                          ) {
                            return showError(
                              "The class timing details are required"
                            );
                          }

                          const newClass = {
                            date: classes.date,
                            time: classes.time,
                            duration: classes.duration,
                          };

                          const updatedList = [...currentClassList, newClass];
                          const sorted = sortEventsByDateTime(updatedList);
                          setCurrentClassList(sorted);

                          setClasses({
                            title: "",
                            description: "",
                            fee: "",
                            date: "",
                            time: "",
                            duration: "",
                          });
                        }}
                      >
                        Add Class
                      </Button>
                    )}
                  </div>
                </Col>

              </Row>
            </Box>
          </div>
        </Container>
      </Container>
    </Container>
  );
};

export default Host3;
